<template>
    <ul class="header__top_account_menu_box_nav">
        <li
            v-for="(item, index) in navItems"
            :key="index"
        >
            <component-button
                :class="['header__top_account_menu_box_nav_item', `header__top_account_menu_box_nav_item--${toKebabCase(item.name)}`]"
                :to="item.routeName ? { name: item.routeName } : ''"
                :text="true"
                :theme="''"
                :size="''"
                :align="'left'"
                :name="'header-top_account-menu-box-nav-button'"
                v-on="item.method ? { 'click' : item.method } : ''"
                :animate-loading="item.method ? true : false"
                :animate-loading-event-name="'reset-onboarding'"
            >{{ item.name }}
            </component-button>
        </li>
    </ul>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'header-top-account-menu-box-nav',
  components: { ComponentButton },
  data () {
    return {
      navItems: [
        { name: 'My profile', routeName: 'lms-user-account-personal' },
        { name: 'Security', routeName: 'lms-user-account-security' },
        { name: 'Activity log', routeName: 'lms-user-account-activity-log' },
        { name: 'Reset onboarding', method: this.resetOnboarding }
      ]
    }
  },
  methods: {
    resetOnboarding () {
      this.$store.dispatch('defaultInductionMessagesReset').finally(() => {
        this.$eventBus.$emit('stop-reset-onboarding')
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/layout/header/headertopaccountmenuboxnav";
</style>
